import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getDevices(page: number, filters: any): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/devices?page=${page}&filters=${JSON.stringify(filters)}`
    );
  }

  getDevicesOffline(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/devices/offline`);
  }

  changeGroupDevice(mac: string, group: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/devices/change-group`, {
      mac,
      group,
    });
  }

  getGroups(page: number, filters: any): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/groups?page=${page}&filters=${JSON.stringify(filters)}`
    );
  }

  createGroup(name: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/groups/create-group`, {
      name,
    });
  }

  deleteGroup(name: string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/groups/delete-group/${name}`);
  }

  getDeploys(page: number, filters: any): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/deploys?page=${page}&filters=${JSON.stringify(filters)}`
    );
  }

  updateDeploy(group: string, model: string, version: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/deploys/update-deploy`, {
      group,
      model,
      version,
    });
  }

  deleteDeploy(group: string, model: string): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/deploys/delete-deploy/${model}/${group}`
    );
  }

  getFirmwares(page: number, filters: any): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/firmwares?page=${page}&filters=${JSON.stringify(filters)}`
    );
  }

  uploadFirmwares(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(
      `${this.apiUrl}/firmwares/update-firmwares`,
      formData
    );
  }

  deleteFirmwares(
    firmwares: { model: string; version: string }[]
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/firmwares/delete-firmwares`,
      firmwares
    );
  }
}
